import axios from 'axios';
import appSettings from '../appSettings';

export const getPolicySummary = async (policyNumber, firstName, lastName, zipCode) => {
  const url = `${appSettings.POLICY_SEARCH_API_BASE_URL}/policy/${policyNumber}/summary?firstName=${firstName}&lastName=${lastName}&zipCode=${zipCode}`;
  const res = await axios.get(url, {headers: {
    'Ocp-Apim-Subscription-Key': appSettings.POLICY_SEARCH_API_SUBSCRIPTION_KEY
  }});
  return res;
}

export const getGWPolicy = async (policyNumber, effectiveDate, accessToken) => {
  const lossDate = new Date(effectiveDate);
  lossDate.setDate(lossDate.getDate() + 2);
  const url = `${appSettings.POLICY_SEARCH_API_BASE_URL}/gw/policy/${policyNumber}?lossDate=${lossDate.toISOString()}`;
  const res = await axios.get(url, {headers: {
    'Authorization': `Bearer ${accessToken}`,
    'Ocp-Apim-Subscription-Key': appSettings.POLICY_SEARCH_API_SUBSCRIPTION_KEY
  }});
  return res;
}
